var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7441 0.730011C5.56109 0.730468 5.37579 0.801844 5.23531 0.942308L0.630721 5.5469C0.3745 5.80312 0.418881 6.24281 0.681965 6.5059L5.23537 11.0593C5.5163 11.3402 5.96834 11.3402 6.24927 11.0593C6.52791 10.7784 6.52928 10.3291 6.24927 10.0491L2.20104 6.00084L6.24927 1.95261C6.53019 1.67168 6.53019 1.21964 6.24927 0.938712C6.10881 0.798251 5.92712 0.729542 5.7441 0.730011Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.eb1d59781063edbae4b05ddecd47fedd.svg";
export { ForwardRef as ReactComponent };